import { auth, db } from '../firebase';

const COLLECTIONS = {
  USERS: 'players',
  GAMES: 'games',
  VANITY: 'profiles',
};

const updateKey = (userId, key, content) => {
  return db
    .collection(COLLECTIONS.USERS)
    .doc(userId)
    .update({
      [key]: content,
    });
};

const updateIterable = (userId, key, content) => {
  return db
    .collection(COLLECTIONS.USERS)
    .doc(userId)
    .update({
      [key]: content,
    });
};

const removeDocument = (id, userId) => {
  return db
    .collection(`${COLLECTIONS.USERS}/${userId}/${COLLECTIONS.ENTITIES}`)
    .doc(id)
    .delete();
};

const findDocument = id => {
  return db
    .collection(`${COLLECTIONS.USERS}`)
    .doc(id)
    .get();
};

const createDocument = (doc, userId) => {
  return db
    .doc(`${COLLECTIONS.USERS}/${userId}`)
    .collection(COLLECTIONS.GAMES)
    .add(doc);
};
const getCollection = userId => {
  return db
    .doc(`${COLLECTIONS.USERS}/${userId}`)
    .collection(COLLECTIONS.GAMES)
    .get();
};

// .collection(
//   `${COLLECTIONS.WIZARDS}/${userId}/${COLLECTIONS.SPELLS}`
// )

const listDocuments = (userId, capped = 100) => {
  return db
    .collection(COLLECTIONS.USERS)
    .limit(capped)
    .get();
};

let contentApi = {
  updateKey,
  removeDocument,
  findDocument,
  createDocument,
  getCollection,
  listDocuments,
  updateIterable,
};

const getUserProfile = id => {
  return (
    db
      .collection(COLLECTIONS.USERS)
      .doc(id)
      // .where('id', '==', id)
      .get()
  );
};
const createUserProfile = (id, initialData) => {
  return db
    .collection(COLLECTIONS.USERS)
    .doc(id)
    .set(initialData);
};

const updateUser = (key, val) => {
  let user = auth.currentUser;
  return user.updateProfile({
    key: val,
  });
  /**
   *  displayName: 'Jane Q. User',
    photoURL: 'https://example.com/jane-q-user/profile.jpg'
   */
};

const updateEmailUser = newEmail => {
  let user = auth.currentUser;
  return user.updateEmail(newEmail);
};

const resetPasswordUser = to => {
  return auth.sendPasswordResetEmail(to);
};

const reportUser = () => {
  let user = auth.currentUser;
  return user;
};

const deleteUser = () => {
  let user = auth.currentUser;
  return user.delete();
};

const tryLogIn = (email, password) => {
  return auth.signInWithEmailAndPassword(email, password);
};
const trySignIn = (email, password) => {
  return auth.createUserWithEmailAndPassword(email, password);
};

const sessionOut = () => {
  return auth.signOut();
};

let userApi = {
  createUserProfile,
  getUserProfile,
  trySignIn,
  tryLogIn,
  resetPasswordUser,
  updateEmailUser,
  sessionOut,
  deleteUser,
  reportUser,
  updateUser,
};

export default {
  ...userApi,
  ...contentApi,
};
